@if (selectedCompany != null) {
  @if (changeCompany) {
    <mat-form-field style="padding: 0px 10px;">
      <mat-select [(ngModel)]="selectedCompany" (selectionChange)="selectionChange($event.value)">
        @for (company of companies; track company) {
          <mat-option [value]="company">
            {{ company.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  @if (!changeCompany) {
    <span>{{selectedCompany.name}}</span>
  }
  @if (!changeCompany && companies.length > 1) {
    <span style="font-size: 12px">
      (<a (click)="change()" href="javascript:void(0);">change</a>)
    </span>
  }
}